<template>
    <v-container>
    <v-breadcrumbs :items="breadCrumbList" class="py-2">
        <template v-slot:item="{ item }">
            <v-breadcrumbs-item
                    :disabled="item.disabled"
                    :to="item.href"
                    :exact="item.exact"
            >
                {{ getBreadcrumbText(item.text) }}
            </v-breadcrumbs-item>
        </template>
    </v-breadcrumbs>
    </v-container>
</template>

<script>
    export default {
        name: "BreadCrumb",
        mounted() { this.updateList() },
        watch : {'$route' () {this.updateList()} },
        data: () => ({
            breadCrumbList: []
        }),
        methods:{
            getBreadcrumbText(text) {
                if (typeof text !== "string") {
                    return text;
                }
                return this.$te(text) ? this.$t(text) : text;
            },
            updateList(){
                this.breadCrumbList = this.$route.meta.breadCrumb
            }
        }
    }
</script>
